module.exports = __webpack_public_path__ + "media/images/iconLockClosed__errorRed--dark-7feee9eacc8d0cb1f3b8679c79815ac1.png";